import Uploadd from "@/components/upload";
import { baseUrlt } from "@/api";
import _ from 'lodash';



export let mixinUpload = {
  data() {
    return {
      fileList: [],
      action: `${baseUrlt}api/attachment/add`,
      btnTitle: '点击上传附件',
      params: {},
      uploadType: '',
      fileTypee: '',
      fileFormName: 'ruleForm',//表名
      fileFieldName: 'file',//字段名
    };
  },
  components: {
    Uploadd
  },
  mounted() {
  },
  methods: {
    setUpFileList(res) {
      if (res.code == 0 && res.data) {
        // this.$message.success("上传成功！")
        if (this.fileTypee == 'file') {
          this.centerDialogVisible = false;
          this.handleQuery();
          this.fileList.push(res.data.url)
        } else {
          this.fileList.push(`${this.$store.state.imgApiUrl + res.data.store_result}`)
          this.setRuleFormVal(this.fileList)
        }
      } else {
        this.$message.success(res.msg)
      }
    },
    setFileListMultiple(res, setFieldNames) {
      const formName = setFieldNames.fileFormNameIn
      const fieldName = setFieldNames.fileFieldNameIn;
      let files = _.get(this[formName], fieldName) ? _.get(this[formName], fieldName).split(",") : [];
      // 如果目标字段不存在或不是数组，初始化为空数组
      if (!Array.isArray(files)) {
        files = [];
      }

      if (res.code == 0 && res.data) {
        // this.$message.success("上传成功！")
        files.push(`${this.$store.state.imgApiUrl + res.data.store_result}`)
        this.setRuleFormValMultiple(setFieldNames, files)
      } else {
        this.$message.success(res.msg)
      }
    },
    setRuleFormValMultiple(setFieldNames, files) {//文件上传必填时,提前设置file值，避免校验失败
      const formName = setFieldNames.fileFormNameIn;
      const fieldName = setFieldNames.fileFieldNameIn;
      if (files) {
        _.set(this[formName], fieldName, files.join(','));
      } else {
        _.set(this[formName], fieldName, '');
      }
    },
    setRuleFormVal(val, setFieldNames) {//文件上传必填时,提前设置file值，避免校验失败
      if (val) {
        this[setFieldNames.fileFormNameIn || this.fileFormName][setFieldNames.fileFieldNameIn || this.fileFieldName] = this.fileList.join(',');
      } else {
        this[setFieldNames.fileFormNameIn || this.fileFormName][setFieldNames.fileFieldNameIn || this.fileFieldName] = '';
      }
    },
    delUpFile(res, setFieldNames) {
      console.log(res)
      this.fileList = []
      if (res.length > 0) {
        res.map(item => {
          if (item.url) {
            // this.fileList.push({ name: item.name, url: item.url })
            this.fileList.push(item.url)
          } else if (item.response) {
            if (item.response.code == 0) {
              // this.fileList.push({ name: item.name, url: item.response.data.store_result })
              this.fileList.push(item.response.data.store_result)
            }
          }
        })
        this.setRuleFormVal(this.fileList, setFieldNames)
      } else {
        this.setRuleFormVal('', setFieldNames)
      }

      // if (res.length > 0) {
      //   res.map(item => {
      //     this.fileList.push(item.url)
      //   })
      // }
      // this.setRuleFormVal(this.fileList)
    }
  }
};
